import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from '@/router';
import VueGtag from 'vue-gtag';
//PrimeVue Library
import vueI18n from './lang/lang.js';
import PrimeVue from 'primevue/config';
//import components
import Button from 'primevue/button';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
// import Paginator from 'primevue/paginator';
import ProgressSpinner from 'primevue/progressspinner';
import Rating from 'primevue/rating';
import Ripple from 'primevue/ripple';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { createMetaManager } from 'vue-meta';

import {
  RiWallet3Line,
  RiFileCopyLine,
  RiLogoutCircleLine,
} from 'vue-remix-icons';
import 'vue-connect-wallet/dist/style.css';

createApp(App)
  .use(createPinia().use(piniaPluginPersistedstate))
  .use(router)
  .use(vueI18n)
  .use(PrimeVue, { ripple: true })
  .use(vueI18n)
  .use(VueGtag, {
    config: { id: 'G-F4SD0BN9YN' },
  })
  .use(createMetaManager())
  .component('RiWallet3Line', RiWallet3Line)
  .component('RiFileCopyLine', RiFileCopyLine)
  .component('RiLogoutCircleLine', RiLogoutCircleLine)
  .component('Button', Button)
  .component('DataView', DataView)
  .component('DataViewLayoutOptions', DataViewLayoutOptions)
  .component('Dialog', Dialog)
  .component('Dropdown', Dropdown)
  .component('InputText', InputText)
  .component('InputNumber', InputNumber)
  .component('Message', Message)
  // .component('Paginator', Paginator)
  .component('ProgressSpinner', ProgressSpinner)
  .component('Rating', Rating)
  .component('TabView', TabView)
  .component('TabPanel', TabPanel)
  .directive('ripple', Ripple)
  .directive('src', (el, binding) => {
    el.style.opacity = 0;
    if (binding.value) {
      const img = new Image();
      img.src = binding.value;
      img.onload = () => {
        el.src = binding.value;
        el.style.opacity = 1;
      };
      img.onerror = () => {
        el.src = require('@/assets/market/placeholder.png');
        el.style.opacity = 1;
        el.style.width = '100%';
        el.style.height = '100%';
      };
    }
  })
  .mount('#app');
